import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmQueuesManageViewRoute: InvariantJiraRoute = {
	name: 'csm-queues-manage-view',
	path: '/jira/customer-service-management/projects/:projectKey/queues/queue-settings',
	exact: true,
};
